import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';

@customElement('finance-banner')
export class FinanceBanner extends LightElement {

	@property({ type: String })
	provider: string = '';

	@property({ type: String })
	instalmentsMessage: string = '';

	@property({ type: String })
	legalMessage: string = '';

	@property({ type: String })
	howItWorksUrl: string = '';

	@property({ type: String })
	iconPath: string = '';

	@property({ type: Boolean })
	isAvailable;

	@property({ type: String })
	additionalCSSClass: string = '';

	@property({ type: Number })
	amount: number;

	render() {

		if (!this.isAvailable || !this.instalmentsMessage) {
			return nothing;
		}

		const providerClass = this.provider.toLowerCase();
		const providerDisplay = this.provider;
		const isStripeMessagingProvider = providerClass === 'klarna' || providerClass === 'clearpay';
		const stripePaymentMethodType = providerClass === 'klarna' ? 'klarna' : 'afterpay_clearpay';

		return html`
			<div class="c-finance-banner ${this.additionalCSSClass}" data-test="finance-banner">
				<div class="c-finance-banner__icon c-finance-banner__icon--${providerClass}" data-test="${providerDisplay}-finance-banner">
				<img
					src="${this.iconPath}"
					alt="${providerDisplay}"
					class="c-finance-banner__icon-image c-finance-banner__icon-image--${providerClass}"
				/>
				</div>
				<div class="c-finance-banner__content">
					${providerClass === 'paypal' ?
						html`<paypal-message amount="${this.amount}" pageType="cart" logoType="none"></paypal-message>
						<span class="u-visuallyhidden" data-test="${providerDisplay}-finance-text">Pay in <span .innerHTML=${this.instalmentsMessage}></span> with <span class="u-bold">${providerDisplay}</span>.</span>`
						: isStripeMessagingProvider ?
						html`<stripe-payment-method-messaging amount="${this.amount}" paymentMethodType="${stripePaymentMethodType}"></stripe-payment-method-messaging>`
						:
						html`<p class="c-finance-banner__content-text">
								<span class="c-finance-banner__content-text-inner" data-test="${providerDisplay}-finance-text">
									Pay in <span .innerHTML=${this.instalmentsMessage}></span> with <span class="u-bold">${providerDisplay}</span>.
								</span>
								<a href="${this.howItWorksUrl}" class="c-finance-banner__link c-basket__item-link" data-test="${providerDisplay}-finance-link">
									Learn more <span class="u-visuallyhidden">about ${providerDisplay}</span>
								</a>
								${this.legalMessage
						? html`<span class="c-finance-banner__content-text-legal" data-test="${providerDisplay}-legal-text">${this.legalMessage}</span>`
						: nothing}
							</p>
							`}
				</div>
			</div>
		`;
	}

}
